"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferMap = void 0;
var buffer_list_1 = require("./buffer-list");
/**
 * A map that only stores a fixed size of items.
 * THe oldest is pushed off when its full
 */
var BufferMap = /** @class */ (function () {
    function BufferMap(maxSize) {
        this.internalMap = new Map();
        this.keys = new buffer_list_1.BufferList(maxSize);
    }
    /**
     * Sets a key value
     */
    BufferMap.prototype.set = function (key, value) {
        var pushedOutKey = this.keys.push(key);
        if (pushedOutKey) {
            this.internalMap.delete(pushedOutKey);
        }
        this.internalMap.set(key, value);
    };
    /**
     * Gets the value of a key
     */
    BufferMap.prototype.get = function (key) {
        return this.internalMap.get(key);
    };
    /**
     * Deletes a key
     */
    BufferMap.prototype.delete = function (key) {
        this.internalMap.delete(key);
        this.keys.filter(function (item) { return item !== key; });
    };
    return BufferMap;
}());
exports.BufferMap = BufferMap;
